import Typography from "@material-ui/core/Typography";
import React from "react";

export const OrganizationUnitBreadcrumbItem = ({
    id,
    currentId,
    name
}: any) => {
    return id === currentId ?
               (<Typography color="textPrimary" variant="body1">{name}</Typography>) :
               (<Typography variant="body2" color="inherit">{name}</Typography>)
};
